import Header from './components/Header';
import { Box, useTheme } from '@mui/material';

type Props = {
  children: JSX.Element;
};

export default function AppLayout({ children }: Props) {
  const theme = useTheme();
  return (
    <>
      <Header />
      <Box bgcolor={theme.palette.background.default} p={3} pt='88px'>
        {children}
      </Box>
    </>
  );
}
